import React, { useState } from 'react';
import { Tabs } from '../components/ui/Tabs';
import { DatiAnagraficiTab } from '../components/settings/DatiAnagraficiTab';
import { ModelliSollecitiTab } from '../components/settings/ModelliSollecitiTab';
import { ConfigurazioneEmailTab } from '../components/settings/ConfigurazioneEmailTab';
import { NotificheTab } from '../components/settings/NotificheTab';
import { SollecitiAutomationsTab } from '../components/settings/SollecitiAutomationsTab';
import { IntegrazioneGestionaliTab } from '../components/settings/IntegrazioneGestionaliTab';
export function Impostazioni() {
  return <div className="space-y-6 pb-16" data-id="element-2080">
      <div data-id="element-2081">
        <h1 className="text-2xl font-semibold text-gray-900" data-id="element-2082">Impostazioni</h1>
        <p className="mt-1 text-sm text-gray-500" data-id="element-2083">
          Configura i parametri del sistema secondo le tue esigenze
        </p>
      </div>
      <Tabs tabs={[{
      id: 'dati-anagrafici',
      name: 'Dati Anagrafici',
      content: <DatiAnagraficiTab data-id="element-2085" />
    }, {
      id: 'modelli-solleciti',
      name: 'Modelli Solleciti',
      content: <ModelliSollecitiTab data-id="element-2086" />
    }, {
      id: 'automazioni',
      name: 'Automazioni',
      content: <SollecitiAutomationsTab data-id="element-2087" />
    }, {
      id: 'integrazione-gestionali',
      name: 'Integrazione Gestionali',
      content: <IntegrazioneGestionaliTab data-id="element-2088" />
    }, {
      id: 'configurazione-email',
      name: 'Configurazione Email',
      content: <ConfigurazioneEmailTab data-id="element-2089" />
    }, {
      id: 'notifiche',
      name: 'Notifiche',
      content: <NotificheTab data-id="element-2090" />
    }]} data-id="element-2084" />
    </div>;
}